import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// import PaperSubmit from './modules/author/PaperSubmit';
// import ReviewerLogin from './modules/reviewer/ReviewerLogin';
// import ReviewerRegister from './modules/reviewer/ReviewerRegister';
// import HostLogin from './modules/host/HostLogin';
// import PlatformManager from './modules/host/PlatformManager';
// import SubmissionHistory from './modules/author/SubmissionHistory';
// import AuthorReply from './modules/author/AuthorReply';
// import AuthorDashboard from './modules/author/AuthorDashboard';
// import ReviewerDashboard from './modules/reviewer/ReviewerDashboard';
// import ReviewerReview from './modules/reviewer/ReviewerReview';
import PlatformList from './components/PlatformList';
// import RegistrationForm from './modules/author/RegistrationForm';
// import LoginForm from './modules/author/LoginForm';  
// import HostRegistration from './modules/host/HostRegistration';
import SideNav from './components/SideNav';
import Header from './components/Header';
import Dashboard from './components/Dashboard';
import Home from './components/Home';
import MainPage from './MainPage';
import CommonLogin from './components/CommonLogin';
// import AuthorLayout from './modules/author/AuthorLayout';
// import ReviewerLayout from './modules/reviewer/ReviewerLayout';
// import VerifyReviewer from './modules/host/VerifyReviewer';
// import VerifyAuthor from './modules/host/VerifyAuthor';
// import SubmissionAssignment from './modules/host/SubmissionAssignment';
// // import SubmissionReview from './modules/reviewer/SubmissionReview'; 
// import ReviewSubmissions from './modules/reviewer/ReviewSubmissions';
// //sujay 24/5/2025 adding the reviewer comments view page
// import ReviewerViewComments from './modules/reviewer/ReviewerViewComment';
// import ReviewerComments from './modules/host/ReviewerComments';
// import ReviewerDecision from './modules/author/ReviewerDecision';
// import PaperProgress from './modules/author/PaperProgress';
// import AuthorsList from './modules/host/AuthorsList';
// import ReviewerList from './modules/host/ReviewerList';
// import SubmissionList from './modules/host/SubmissionList';
// import ReviewRepliesList from './modules/host/ReviewRepliesList'; 
import TestEmailSender from './TestEmailSender';
// import ReviewerDecMatrix from './modules/host/ReviewerDecMatrix';
import ChatView from './components/ChatView';
import AuthorRoutes from './commonRoutes/AuthorRoute';
import ReviewerRoutes from './commonRoutes/ReviewerRoutes';
import HostRoutes from './commonRoutes/HostRoutes';
import AdminRoutes from './commonRoutes/AdminRoutes';
import ForgetPass from './commonRoutes/ForgetPassRoute';

//mport ProjectProgress from './modules/author/ProjectProgress';
function App() {
  return (
    <Router>
      <Routes>
        {/* <Route path="/chat" element={<ChatView />} /> */}
        {/* <Route path="/author/login" element={<AuthorLogin />} />
        <Route path="/author/register" element={<AuthorRegister />} /> */}
        {AuthorRoutes}
        {/* Reviwer Routes */}
        {ReviewerRoutes}
        {/* Host Routes */}
        {HostRoutes}
        {/* Admin Routes */}
        {AdminRoutes}
        {/* forget pass */}
         {ForgetPass}
        <Route path="/PlatformList" element={<PlatformList />} />

        <Route path="/sidenav" element={<SideNav />} />
        <Route path="/header" element={<Header />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/home" element={<Home />} />
        <Route path="/" element={<MainPage />} />
        <Route path="/cl" element={<CommonLogin />} />
        <Route path="/test-email" element={<TestEmailSender />} />
        {/* Add more routes as needed */}
      </Routes>
    </Router>
  );
}

export default App;
